module.exports =  {
    login: {
        loginhello:"你好",
        loginTitle: "欢迎登录",
    }
}
